import React from "react";
import "./Hero.css";
const Hero = () => {
  return (
    <div className="container-fluid bg-img1">
      <div className="hero-text">
        <h1 className="title tit text-center">ABOUT US</h1>
        <p className="para" style={{ fontSize: "18px" }}>
          Founded in 2020, Al-Nisa Quran Institute has quickly become a trusted
          leader in online Quranic education. Our mission is to provide
          accessible and high-quality Quran learning to students worldwide.
          Through our dedicated online platform, we have successfully guided
          hundreds of students in mastering Quran recitation, gaining a profound
          understanding of Tajweed, and deepening their knowledge of Quranic
          Arabic and Tafseer.
          <br />
          <br />
          At Al-Nisa, our commitment to excellence drives us to continually
          improve our curriculum and teaching methods, ensuring every student
          receives the best possible Quranic education. Whether you’re looking
          to begin your Quranic journey, enhance your recitation skills, or
          embark on the blessed path of Hifz al Quran, we are here to support
          and nurture your spiritual growth.
          <br />
          <br />
          {/* In today’s digital era, learning the Quran has never been more
          convenient. With Al-Nisa, you are just one step away from connecting
          with experienced, professional Quranic educators—all from the comfort
          of your home. Join us and become part of a community dedicated to
          deepening its understanding of the Quran. */}
        </p>
      </div>
    </div>
  );
};

export default Hero;
